import clsx from 'clsx'
import React from 'react'
import type { TPhase, TPhaseGroup } from 'types/classAndPhases'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { getFirstAndLastItem } from 'utils/array'
import { getClassesByPhase } from 'utils/classAndPhases'

import { KESETARAAN_PHASE_PACKET_MAPPING } from 'data/classAndPhases'

interface TSelectedPhaseProps {
  handleFilterChange: (value: 'phase' | 'subject') => void
  phase: TPhase[]
  phaseGroup: TPhaseGroup
  className?: string
}

const SelectedPhase = ({
  handleFilterChange,
  phase,
  phaseGroup,
  className,
}: TSelectedPhaseProps) => {
  const classes = getClassesByPhase(phase)

  const phaseClasses = React.useMemo(() => {
    if (!classes) return ''

    const parsedClasses = classes?.map((klass) => klass.replace('Kelas ', ''))
    if (parsedClasses?.length > 2) {
      return getFirstAndLastItem(parsedClasses as string[]).join('-')
    }

    return `Kelas ${parsedClasses?.join('-')}`
  }, [classes])

  const phaseGroupText = React.useMemo(() => {
    if (!phaseGroup || phaseGroup === 'Umum' || phaseGroup === 'Kesetaraan')
      return ''
    return ` ${phaseGroup}`
  }, [phaseGroup])

  return (
    <span
      onClick={() => handleFilterChange('phase')}
      className={clsx(
        'flex w-full cursor-pointer justify-between rounded-[4px] !border !border-default py-3 px-4',
        className || ''
      )}
    >
      <Text color={phase ? 'default' : 'disabled'} className="truncate">
        {phaseGroup === 'Kesetaraan' &&
          `Paket ${KESETARAAN_PHASE_PACKET_MAPPING[phase?.[0]]} • `}
        {phase ? `Fase ${phase}` : 'Pilih fase (kelas)'}
        {phaseClasses ? ` • ${phaseClasses}` : ''}
        {phaseGroupText}
      </Text>
      <Icon>arrow_drop_down</Icon>
    </span>
  )
}

SelectedPhase.displayName = 'SelectedPhase'

export default SelectedPhase
